import { bindActionCreators } from 'redux';

import store from '../../store';
import Logger from '../../services/Logger';
import localization from '../../shared/strings';
import { duplicateAssets } from '../../store/actions/assets';
import { getChildren } from '../../store/actions/collections';
import getRenditionSupportSummary from '../assets/getRenditionSupportSummary';
import showSelectFromTreeDialog from '../showSelectFromTreeDialog';
import showAssetsCopyDialog from '../showAssetsCopyDialog';

const collectionsActions = bindActionCreators({ getChildren }, store.dispatch);

/**
 * Opens the standard collection picker + AssetsCopyDialog for assets that need
 * a Shopify-compatible version. Does not resume the attach/sync flow.
 */
export default function openAssetsCopyForShopifyPrepare(assets = []) {
  const assetList = (assets || []).filter(Boolean);
  if (!assetList.length) return;

  const assetIds = assetList.map(({ _id }) => _id);
  const myCollection = store.getState().collections.collections.my;
  const renditionSupport = getRenditionSupportSummary(assetList);
  const sourceMimeTypes = [...new Set(
    assetList.map(({ mimeType }) => mimeType).filter(Boolean),
  )];

  Logger.log('UI', 'PrepareMediaForShopifyOpenAssetCopy', {
    assetsCount: assetIds.length,
  });

  showSelectFromTreeDialog({
    title: localization.DIALOGS.DUPLICATE_ASSET_TO.TITLE,
    treeListItems: [myCollection],
    onLoadChildren: async (item) => collectionsActions.getChildren(item._id),
    onOk: async (selectedCollections) => {
      showAssetsCopyDialog({
        shouldFormatBeDisabled: renditionSupport.allUnsupported,
        unsupportedFormatsCount: renditionSupport.unsupportedCount,
        sourceMimeType: sourceMimeTypes.length === 1 ? sourceMimeTypes[0] : undefined,
        duplicateSelectionCount: assetIds.length,
        copyPreviewAssetId: assetIds.length === 1 ? assetIds[0] : undefined,
        assets: assetList,
        onConfirm: (convertingParams) => {
          store.dispatch(duplicateAssets(
            assetIds,
            selectedCollections[0]._id,
            true,
            true,
            convertingParams,
          ));
        },
      });
    },
  });
}
